import React from "react"
import { connect } from "react-redux"
import { formValueSelector } from "redux-form"
import { List } from "../../shared/list"
import { PageHeader } from "../../shared/pageHeader"
import { getColumns } from "./constants"
import { getClientList } from "../../../store/actions/clientActions"
import TextSearchForm from "../../forms/textSearchForm"
import _ from "lodash"

class ClientListPage extends React.Component {

    state = {
        page: 1,
        searchQuery: ""
    }

    componentDidMount() {
        this.getClients()
    }

    componentDidUpdate(prevProps, prevState) {
        const { page, searchQuery } = this.state
        const { query } = this.props
        if (prevState.page !== page || prevState.searchQuery !== searchQuery) {
            this.getClients()
        }

        if (prevProps.query !== query) {
            this.setState({
                searchQuery: _.trim(query)
            })
        }
    }

    getClients = () => {
        const { page, searchQuery } = this.state
        const { getClientList } = this.props
        getClientList({
            page,
            query: searchQuery
        })
    }

    onPageHeaderActionClick = (action, addtionalParams) => {
        const { history } = this.props
        if (action === "add") {
            history.push("/clients/add")
        } else if (action === "edit") {
            history.push(`/clients/edit/${addtionalParams.id}`)
        }
    }

    onPageChange = (page) => {
        this.setState({
            page: page + 1
        }, () => {
            this.getClients()
        })
    }

    onTextFormSubmit = (values) => {
        this.setState({
            searchQuery: _.trim(values.query)
        })
    }

    render() {
        const { clients } = this.props
        return (
            <>
                <PageHeader
                    title="Clients"
                    actions={['add']}
                    onAction={this.onPageHeaderActionClick}
                    searchComponent={<TextSearchForm onSubmit={this.onTextFormSubmit} />}
                />
                <List
                    pagination={(clients.list && clients.list.pagination) || {}}
                    columns={getColumns(this.onPageHeaderActionClick)}
                    data={(clients.list && clients.list.data) || []}
                    isLoading={clients.requesting}
                    onPageChange={this.onPageChange}
                    sortCol="clientName"
                />
            </>
        )
    }
}
const selector = formValueSelector("textSearchForm")
const mapStateToProps = ({ clients, ...state }) => ({ clients, query: selector(state, 'query') })

const mapDispatchToProps = () => ({
    getClientList
})

export default connect(mapStateToProps, mapDispatchToProps())(ClientListPage)